<template>
    <div class="pageBox">
        <div class="option">
            <el-button @click="add()">创建一级分类</el-button>
        </div>
        <div class="table" ref="table">
            <el-table element-loading-text="数据加载中..." v-loading="loading" :height='height' :data="list" border>
                <el-table-column type="expand">
                    <template slot-scope="scope" v-if="scope.row.children.length > 0">
                        <!-- 二级分类表格 -->
                        <el-table :data="scope.row.children" border>
                            <el-table-column prop="name" label="二级分类名称" align="center">
                            </el-table-column>
                            <el-table-column label="二级分类操作" align="center" width="200">
                                <template slot-scope="scope2">
                                    <el-button @click="edit2(scope2.row)" type="text">编辑</el-button>
                                    <el-button @click="remove2(scope2.row)" type="text">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </template>
                </el-table-column>
                <el-table-column label="序号" type="index" align="center" width="100">
                </el-table-column>
                <el-table-column prop="name" label="一级分类名称" align="center">
                </el-table-column>
                <el-table-column label="封面图" align="center">
                    <template slot-scope="scope">
                        <el-image v-if="scope.row.iconUrl" style="width: 50px; height: 50px" :src="scope.row.iconUrl"
                            :preview-src-list="[scope.row.iconUrl]">
                        </el-image>
                        <span v-else>暂无图片</span>
                    </template>
                </el-table-column>
                <el-table-column label="二级分类" align="center">
                    <template slot-scope="scope">
                        <span>{{scope.row.children.length > 0 ? scope.row.children.map(item => item.name).join('、')
                            : '暂无二级分类'}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" label="创建时间" align="center">
                </el-table-column>
                <el-table-column label="操作" align="center" width="200">
                    <template slot-scope="scope">
                        <el-button @click="add2(scope.row)" type="text">新增</el-button>
                        <el-button @click="edit(scope.row)" type="text">编辑</el-button>
                        <el-button @click="remove(scope.row)" type="text">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-dialog :close-on-click-modal="false" title="一级分类" :visible.sync="dialogShow" width="30%">
            <el-form label-width="100px">
                <el-form-item label="一级分类名称">
                    <el-input v-model="name" placeholder="请输入一级分类名称"></el-input>
                </el-form-item>
                <el-form-item label="封面图上传">
                    <el-upload v-if="fileListLoaded && dialogShow" list-type="picture-card"
                        :on-preview="handlePictureCardPreview" :on-exceed="handleExceed" :on-remove="handleRemove"
                        :on-change="handleFileChange" :limit="1" :multiple="false" :file-list="fileList" action=""
                        :auto-upload="false">
                        <i class="el-icon-plus"></i>
                    </el-upload>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogShow = false">关闭</el-button>
                <el-button type="primary" @click="confirm">确定</el-button>
            </span>
        </el-dialog>
        <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
    </div>
</template>
<script>
import { categoryAdd, categoryEdit, categoryRemove, categoryTree, fileRemove, fileUpload } from '../api.js';
export default {
    data() {
        return {
            height: 0,
            loading: true,
            dialogShow: false,
            list: [],
            dialogImageUrl: '',
            dialogVisible: false,
            name: '',
            parentId: null,
            iconUrl: "",
            fileList: [],
            id: null,
            fileListLoaded: false
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.getElementHeight()
        })
        this.getList()
    },
    methods: {
        confirm() {
            if (!this.name) {
                this.$message({
                    duration: 1500,
                    type: 'error',
                    message: '请输入一级分类名称'
                });
                return
            }
            if (this.id) {
                categoryEdit({ id: this.id, name: this.name, iconUrl: this.iconUrl }).then(res => {
                    if (res.code === 0) {
                        this.$message({
                            duration: 1500,
                            type: 'success',
                            message: '编辑一级分类成功'
                        });
                        this.dialogShow = false
                        this.getList()
                    }
                })
            } else {
                categoryAdd({ name: this.name, iconUrl: this.iconUrl }).then(res => {
                    if (res.code === 0) {
                        this.$message({
                            duration: 1500,
                            type: 'success',
                            message: '创建一级分类成功'
                        });
                        this.dialogShow = false
                        this.getList()
                    }
                })
            }
        },
        add() {
            this.id = null
            this.name = ''
            this.iconUrl = ''
            this.fileList = []
            this.fileListLoaded = true;
            this.dialogShow = true
        },
        add2(row) {
            this.$prompt('', '新增二级分类', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputPlaceholder: '请输入二级分类名称'
            }).then(({ value }) => {
                if (!value) {
                    return
                }
                categoryAdd({ name: value, parentId: row.id }).then(res => {
                    if (res.code === 0) {
                        this.$message({
                            duration: 1500,
                            type: 'success',
                            message: '创建二级分类成功'
                        });
                        this.getList()
                    }
                })
            }).catch(() => {
            });
        },
        edit2(row) {
            this.$prompt('', '编辑二级分类', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputPlaceholder: '请输入二级分类名称',
                inputValue: row.name
            }).then(({ value }) => {
                if (!value) {
                    return
                }
                categoryEdit({ id: row.id, name: value, }).then(res => {
                    if (res.code === 0) {
                        this.$message({
                            duration: 1500,
                            type: 'success',
                            message: '编辑二级分类成功'
                        });
                        this.getList()
                    }
                })
            }).catch(() => {
            });
        },
        remove2(row) {
            this.$confirm(`确定要删除该二级分类吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                categoryRemove(row.id).then(res => {
                    if (res.code == 0) {
                        this.$message({
                            duration: 1500,
                            type: 'success',
                            message: '删除成功'
                        });
                        this.getList()
                    }
                })
            }).catch(() => {
            });
        },
        edit(row) {
            this.id = row.id
            this.name = row.name
            this.fileList = row.iconUrl ? [{ name: row.iconUrl.split('/').pop(), url: row.iconUrl }] : []
            this.iconUrl = row.iconUrl ? row.iconUrl : ''
            this.fileListLoaded = true;
            this.dialogShow = true
        },
        remove(row) {
            this.$confirm(`确定要删除该一级分类吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                categoryRemove(row.id).then(res => {
                    if (res.code == 0) {
                        this.$message({
                            duration: 1500,
                            type: 'success',
                            message: '删除成功'
                        });
                        this.getList()
                    }
                })
            }).catch(() => {
            });
        },
        handleFileChange(file, fileList) {
            const formData = new FormData();
            formData.append('file', file.raw);
            fileUpload(formData).then(res => {
                if (res.code === 0) {
                    this.iconUrl = res.data
                }
            })
        },
        handleRemove(file, fileList) {
            this.iconUrl = ''
            this.fileList = []
        },
        handleExceed() {
            this.$message.error('请删除后重新上传')
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        getList() {
            this.loading = true
            categoryTree().then(res => {
                if (res.code === 0) {
                    this.loading = false
                    this.list = res.data
                }
            })
        },
        getElementHeight() {
            const container = this.$refs.table;
            if (container) {
                this.height = container.offsetHeight
            }
        },
    }
}
</script>
<style scoped lang="less">
.pageBox {
    width: 100%;
    height: 100%;
    padding: 20px 50px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;

    .option {
        margin-bottom: 20px;
        display: flex;
        justify-content: flex-end;
    }

    .table {
        flex: 1;
    }
}
</style>